import commonEnglish from "./common.json";
import customerEnglish from "./customers.json";
import dashboardEnglish from "./dashboard.json";
import embeddedEnglish from "./embedded.json";
import navigationEnglish from "./navigation.json";
import notificationEnglish from "./notifications.json";
import reportEnglish from "./reports.json";
import settingsEnglish from "./settings.json";
import sharedEnglish from "./shared.json";
import ticketEnglish from "./tickets.json";

export const englishJson = {
  ...commonEnglish,
  ...customerEnglish,
  ...dashboardEnglish,
  ...embeddedEnglish,
  ...navigationEnglish,
  ...notificationEnglish,
  ...reportEnglish,
  ...settingsEnglish,
  ...sharedEnglish,
  ...ticketEnglish,
};
